import React, {Component} from 'react';
import * as ReactDOM from "react-dom";
import styled from 'styled-components';
import {mixins} from "../../mixins";

const Input = styled.div`
  position: relative;
  padding: 21px 0;
`;

const Bar = styled.div`
    width: 100%;
    height: 1px;
    border-radius: 0.5px;
    position: relative;
    background-color: ${p => p.theme.cMicrocopyText};
    &:before, &:after{
      top: -6px;
      position: absolute;
      ${mixins.pseudoToBlock()};
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 6.5px 6px 6.5px 0;
      border-color: transparent  ${p => p.theme.cMicrocopyText} transparent transparent;
    }
    &:before{
      left: 0;
      border-width: 6.5px 6px 6.5px 0;
      border-color: transparent  ${p => p.theme.cMicrocopyText} transparent transparent;
    }
    &:after{
      right: 0;
      border-width: 6.5px 0 6.5px 6px ;
      border-color: transparent  transparent transparent ${p => p.theme.cMicrocopyText};
    }
`;

const Progress = styled.div`
    position: absolute;
    top: -1px;
    left: 3px;
    height: 3px;
    border-radius: 1.5px;
    background-color: ${p => p.theme.cMicrocopyText};
`;

const Handle = styled.div`
    height: 36px;
    width: 36px;
    background-color: ${p => p.theme.cTheme};
    top: 4px;
    margin-left: -18px;
    position: absolute;
    cursor: pointer;
    ${mixins.ease(0.5)};
    transition-property: background-color, box-shadow;
    &:before, &:after{
      ${mixins.pseudoToBlock()};
      position: absolute;
      box-sizing: border-box;
      top: 14px;
      height: 8px;
      width: 8px;
      border: 2px solid ${p => p.theme.cWhite};
      ${mixins.ease(0.25)};
    }
    &:before{
      left: 10px;
      transform: rotate(-45deg);
      border-bottom: 0 solid transparent;
      border-right: 0 solid transparent;
    }
    &:after{
      right: 10px;
      transform: rotate(45deg);
      border-bottom: 0 solid transparent;
      border-left: 0 solid transparent;
    }
    &:hover, &:focus, &.active{
      background-color: ${p => p.theme.cThemeActive};
      &:before{
        left: 9px;
      }
      &:after{
        right: 9px;
      }
    }
`;

class RangeInput extends Component {
    constructor(props) {
        super(props);

        this.state = {
            active: false,
        };

        this.getWidth = this.getWidth.bind(this);
        this.handleDrag = this.handleDrag.bind(this);
        this.initializeMove = this.initializeMove.bind(this);
        this.handleProgressChange = this.handleProgressChange.bind(this);

        this.input = React.createRef();
        this.bar = React.createRef();
        this.progress = React.createRef();
        this.handle = React.createRef();
    }

    getWidth() {
        const rangeMax = this.props.max - this.props.min;
        const rangeValue = this.props.value - this.props.min;
        let width = (rangeValue / rangeMax * 100);
        if (width < 0) {
            width = 0;
        }
        else if (width > 100) {
            width = 100
        }
        return width + '%';
    }

    initializeMove(initialX, bar, initialProgress) {
        const callback = this.handleProgressChange;
        this.setState({active: true});

        function calculate(e) {
            const delta = e.clientX - initialX;
            const newProgress = (initialProgress + delta) / bar;
            callback(newProgress);
        }

        function removeListeners() {
            if(this.input.current != null){
                this.setState({active: false});
            }
            document.removeEventListener('mousemove', calculate);
            document.removeEventListener('mouseup', removeListeners);
        }

        document.addEventListener('mousemove', calculate);
        document.addEventListener('mouseup', removeListeners.bind(this));
    }

    handleProgressChange(newProgress) {
        if (typeof (this.props.callback) === 'function') {
            this.props.callback(newProgress);
        }
        else {

        }
    };

    handleDrag(e) {
        e.preventDefault();
        e.stopPropagation();
        this.initializeMove(e.pageX, this.bar.current.getBoundingClientRect().width, this.progress.current.getBoundingClientRect().width);
    }

    render() {
        const p = this.props;
        return (
            <Input ref={this.input}>
                <Bar ref={this.bar}>
                    <Progress style={{width: this.getWidth()}} ref={this.progress}/>
                </Bar>
                <Handle className={this.state.active ? 'active' : ''}
                     style={{left: this.getWidth()}}
                     onMouseDown={(e) => {
                         this.handleDrag(e)
                     }}
                     ref={this.handle}
                />
            </Input>
        )
    }
}

export default RangeInput;